import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { GenericAbsService } from '../utils/generic-abs-service';
import { ApiResponse, PromotionCriteria, PromotionDto } from '../objects';
import { moduleConfigToken, AbdaliModuleConfig } from '../app.module';

@Injectable()
export class PromotionService extends GenericAbsService<ApiResponse> {

    constructor(@Inject(moduleConfigToken) private config: AbdaliModuleConfig, private http: HttpClient) {
        super(config.baseUrl, http);
    }

    getByCriteria(criteria: PromotionCriteria, headers?: HttpHeaders) {
        let endpoint = '/api/v1/promotion'; 
        endpoint = `${endpoint}?code=${criteria.code ? criteria.code : ''}`;
        if (criteria.endDateFrom) {
            endpoint = `${endpoint}&endDateFrom=${criteria.endDateFrom}`;
        }
        if (criteria.endDateTo) {
            endpoint = `${endpoint}&endDateTo=${criteria.endDateTo}`;
        }
        if (criteria.id) {
            endpoint = `${endpoint}&id=${criteria.id}`;
        }
        if (criteria.startDateFrom) {
            endpoint = `${endpoint}&startDateFrom=${criteria.startDateFrom}`;
        }
        if (criteria.startDateTo) {
            endpoint = `${endpoint}&startDateTo=${criteria.startDateTo}`;
        }
        if (criteria.statusId) {
            endpoint = `${endpoint}&statusId=${criteria.statusId}`;
        }
        endpoint = `${endpoint}&pageIndex=${criteria.pageIndex ? criteria.pageIndex : ''}&pageSize=${criteria.pageSize ? criteria.pageSize : ''}`;

        return this.getAll(endpoint, headers);
    }

    getByCode(code: string, headers?: HttpHeaders) {
        const endpoint = '/api/v1/promotion/' + code;
        return this.getAll(endpoint, headers);
    }

    insert(dto: PromotionDto, headers?: HttpHeaders) {
        const endpoint = '/api/v1/promotion'; 
        return this.post(endpoint, dto, headers);
    }

    update(dto: PromotionDto, headers?: HttpHeaders) {
        const endpoint = '/api/v1/promotion'; 
        return this.put(endpoint, dto, headers);
    }
}
